import React from 'react';
import { Typography } from '@/components/common';
import { SignReviewProfileItem } from '@/interfaces';
import { ReviewFieldRow } from './ReviewFieldRow';

interface Props {
	profileItems: SignReviewProfileItem[];
}

export const ProfileInformationCard: React.FC<Props> = ({ profileItems }) => {
	if (profileItems.length === 0) return null;

	return (
		<div className="border border-grey-100 rounded-2xl p-4 flex flex-col gap-4 h-full min-h-0">
			<Typography type="semibold-14" className="text-left shrink-0">
				Profile Information
			</Typography>
			<div className="flex-1 min-h-0 overflow-y-auto scroll-custom flex flex-col gap-3">
				{profileItems.map((item, index) => (
					<ReviewFieldRow
						key={`${item.label}-${index}`}
						label={item.label}
						value={item.value}
					/>
				))}
			</div>
		</div>
	);
};
